

























import {
  Vue,
  Component,
  Watch,
} from "@/shared/vuepack";
import moment from "moment";
import { formatCurrency } from "@/shared/currency";
import { usePayrollDashboardStore } from "@/employer/store/payrollDashboard";
import { useUserStore } from "@/shared/store/user";

@Component
export default class FicaSavingsWidget extends Vue {
  userStore = useUserStore();
  dashboardStore = usePayrollDashboardStore();

  formatCurrency = formatCurrency;

  mounted (): void {
    this.onEmployerIdChange();
  }

  @Watch("userStore.employerId")
  onEmployerIdChange () {
    this.dashboardStore.initEmployeeContributionsGraph(moment().year());
  }

  get hasFicaSavings (): boolean {
    return !!this.dashboardStore.ficaSavingsCurrentYear;
  }
}
